import script from "./artemisadsDivid.vue?vue&type=script&setup=true&lang=js"
export * from "./artemisadsDivid.vue?vue&type=script&setup=true&lang=js"

import "./artemisadsDivid.vue?vue&type=style&index=0&id=bddd7000&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bddd7000"]])

export default __exports__